export const WORKPLANTABLECOLUMNSALL_REQUEST = "WORKPLANTABLECOLUMNSALL_REQUEST";
export const WORKPLANTABLECOLUMNSALL_SUCCESS = "WORKPLANTABLECOLUMNSALL_SUCCESS";
export const WORKPLANTABLECOLUMNSALL_FAIL = "WORKPLANTABLECOLUMNSALL_FAIL";